import _regeneratorRuntime from "@babel/runtime-corejs2/regenerator";
import _asyncToGenerator from "@babel/runtime-corejs2/helpers/esm/asyncToGenerator";
import _classCallCheck from "@babel/runtime-corejs2/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime-corejs2/helpers/esm/createClass";
import _defineProperty from "@babel/runtime-corejs2/helpers/esm/defineProperty";
import { SessionLogoutListenerServiceStrategy } from './SessionLogoutListenerServiceStrategy';
import { SessionManagerLogoutListenerStrategy } from '../types';
export var SessionLogoutListener = /*#__PURE__*/function () {
  function SessionLogoutListener(config) {
    _classCallCheck(this, SessionLogoutListener);

    _defineProperty(this, "strategy", void 0);

    switch (config.strategy) {
      case SessionManagerLogoutListenerStrategy.Service:
        this.strategy = new SessionLogoutListenerServiceStrategy(config);
        break;
    }
  }

  _createClass(SessionLogoutListener, [{
    key: "start",
    value: function () {
      var _start = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(isSessionInitialization) {
        var _this$strategy;

        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                return _context.abrupt("return", (_this$strategy = this.strategy) === null || _this$strategy === void 0 ? void 0 : _this$strategy.start(isSessionInitialization));

              case 1:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function start(_x) {
        return _start.apply(this, arguments);
      }

      return start;
    }()
  }, {
    key: "stop",
    value: function () {
      var _stop = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
        var _this$strategy2;

        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                return _context2.abrupt("return", (_this$strategy2 = this.strategy) === null || _this$strategy2 === void 0 ? void 0 : _this$strategy2.stop());

              case 1:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function stop() {
        return _stop.apply(this, arguments);
      }

      return stop;
    }()
  }]);

  return SessionLogoutListener;
}();
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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